<template>
    <div class="animated fadeIn"  @keyup.esc="cancelGrn">
        <b-row> 
            <b-col sm="12">
                <b-card v-if="!isPORetrieved">
                    <div slot="header">
                        <strong>{{title}}</strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group name="po" label="PO No" label-for="elementsPrependAppend" description="">
                                <b-input-group>
                                    <poLookup style="min-width:300px" v-bind:url="poLookupUrl" v-on:selected="setPoId($event)" :basic="1" ref="poLookupInput" :lookupId="grn.po_num"/>&nbsp;&nbsp;&nbsp;
                                    <b-button variant="primary" @click="retrievePO" :disabled="grn.po_num == ''">Retrieve PO</b-button>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="isPORetrieved">
                    <div slot="header">
                        <strong>{{title}}</strong>
                    </div>
                    <b-row>
                        <b-col>
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group>
                                        <label for="grn_date">GRN Date</label>
                                        <b-form-input type="date" id="grn_date" v-model="grn.grn_date"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <label for="grn_remarks">GRN Remarks</label>
                                    <textarea class="form-control" rows="5" id="remarks" v-model="grn.remarks"></textarea>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col v-if="grn.po.grns.length > 0" sm="6">
                            <br/>
                            <b-card>
                                <div class="table-responsive">
                                    <table>
                                        <thead>
                                            <th style="min-width:138px;height:40px">GRN No</th>
                                            <th style="min-width:100px">Date</th>
                                            <th>Generated By</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row, index in grn.po.grns" :ref="'title'" style="height:40px">
                                                <td>
                                                    <b-button type="submit" size="md" variant="primary" @click="printGRN(row)">{{row.grn_num}} </b-button>
                                                </td>
                                                <td>{{row.grn_date_friendly}}</td>
                                                <td>{{row.author_user_shortname}}</td>
                                            </tr>
                                        </tbody>
                                    </table> 
                                </div>
                            </b-card>
                        </b-col>                            
                    </b-row>
                    <br/>
                    <hr>
                    <br/>
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="po_num">PO No</label>
                                <b-form-input type="text" v-model="grn.po_num" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="po_num">PO Date</label>
                                <b-form-input type="date" v-model="grn.po.po_date" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="po_type">PO Type</label>
                                <b-form-input type="text" v-model="grn.po.po_type" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                                <b-form-group>
                                    <label for="po_type">Fulfilment Status</label>
                                    <b-form-input type="text" v-model="grn.po.po_fulfilment_status" disabled></b-form-input>
                                </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="supplier">Supplier</label>
                                <b-form-input type="text" v-model="grn.po.supplier_full" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="location">Receiving Warehouse</label>
                                <b-form-input type="text" v-model="grn.po.location_full" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="deliveryDate">Delivery Date</label>
                                <b-form-input type="date" v-model="grn.po.po_date_eta" disabled></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="3">
                            <b-form-group>
                                <label for="po_type">PO Status</label>
                                <b-form-input type="text" v-model="grn.po.po_status" disabled></b-form-input>
                            </b-form-group>
                    </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <label for="remarks">PO Remarks</label>
                                <textarea class="form-control" rows="5" id="remarks" v-model="grn.po.remarks" disabled></textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="isPORetrieved">
                <b-col sm="12">
                    <b-card>
                        <div slot ="header">
                            <strong>GRN Items</strong>
                        </div>
                        <div class="table-responsive">
                            <table class='table table-striped table-bordered'>
                                <thead>
                                    <th width="10px">S/N</th>
                                    <th style="min-width:300px">Product</th>
                                    <th width="150px">SKU</th>
                                    <th width="150px">PO Qty</th>
                                    <th width="180px">Balance</th>
                                    <th width="180px">Received Qty</th>
                                    <th width="180px">Update Qty</th>
                                </thead>
                                <tbody>
                                    <tr v-for="row, index in grn.po.po_items" >
                                        <td>{{(index*1) +1}}</td>
                                        <td>{{row.product_name}}</td>
                                        <td>{{row.product_id}}</td>
                                        <td>{{row.qty*1}}</td>
                                        <td>{{row.qty - (row.qty_received*1 + row.qty_received_current*1)}}</td>
                                        <td>{{(row.qty_received*1 + row.qty_received_current*1)}}</td>
                                        <td><input type="number" name="update-qty" class="form-control" v-model="row.qty_received_current"  v-if="row.qty - (row.qty_received *1) > 0 && grn.po.po_fulfilment_status != 'MANUAL CLOSED' && grn.po.po_status != 'CANCELLED'"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row v-if="isPORetrieved" style="padding:0px 0px 20px 18px">
                    <b-button type="submit" size="lg" variant="primary" @click="confirmSave" v-if="grn.po.po_fulfilment_status != 'FULFILLED' && grn.po.po_fulfilment_status != 'MANUAL CLOSED' && grn.po.po_status == 'APPROVED'">Save GRN </b-button>
                    &nbsp;&nbsp;
                    <b-button type="button" size="lg" variant="danger" @click="confirmCancel" v-if="grn.po.po_fulfilment_status != 'FULFILLED' && grn.po.po_fulfilment_status != 'MANUAL CLOSED' && grn.po.po_status == 'APPROVED'">Cancel</b-button>
                    <b-button type="button" size="lg" variant="success" @click="print" v-if="grn.po.po_fulfilment_status == 'FULFILLED' || grn.po.po_fulfilment_status == 'MANUAL CLOSED' || grn.po.po_status == 'PENDING' || grn.po.po_status == 'CANCELLED'">Print</b-button>&nbsp;&nbsp;
                    <b-button type="button" size="lg" variant="danger" @click="back" v-if="grn.po.po_fulfilment_status == 'FULFILLED' || grn.po.po_fulfilment_status == 'MANUAL CLOSED' || grn.po.po_status == 'PENDING' || grn.po.po_status == 'CANCELLED'">Back</b-button>
            </b-row>
            <b-row>
                <b-modal v-model="modalShow" @ok="save"  title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                    <p style="color:darkblue">Confirmed Save?</p>
                </b-modal>
                <b-modal v-model="modalCancelShow" @ok="cancel"  title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                    <p style="color:darkblue">Confirmed Cancel?</p>
                </b-modal>
                <b-modal ref="myModalRef" hide-header-close hide-footer title="GRN with PO" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                    <div class="d-block text-center">
                        <p>Goods Receive Note <strong style="color:green"> {{grnDocNo}}</strong> is saved.<br/><br/></p>
                     </div>
                        <b-btn class="float-right" variant="outline-danger" @click="hideModal">OK</b-btn>
                </b-modal>
                <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                    <div class="d-block text-center">
                        <p style="color:red">{{errorMessage}}</p>
                    </div>
                    <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
                </b-modal>
            </b-row>
    </div>
</template>
<script>
import axios from 'axios'
import poLookup from '@/components/Autocomplete.vue'
import {authHeader, apiPOLookup,apiGRNSave,apiCountryLookup} from '@/functions/common.vue'
import productLookup from '@/components/Autocomplete.vue'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    },
};
export default
{
    name: 'grn',
    components: {poLookup},
    created: function()
    {
        
        if (localStorage.getItem("grn_new.po_num") != "")
        {
            this.isPORetrieved = true
            var poNum = localStorage.getItem("grn_new.po_num")
            var url = this.poLookupUrl
            axios.get(url, {params: {q: poNum, get:1}})
            .then(response => 
            {
                this.list = response.data.data.list
                
                if (this.list.length>0)
                {
                    this.item = this.list[0]
                    console.log(this.item)
                    if (this.item !== null)
                    {
                        var po = this.item
                       // console.log(po.country_id)
                        if(po.country_id != null)
                            {
                                axios.get(apiCountryLookup, {params: {q: po.country_id}})
                                    .then(response => 
                                    {
         
                                        if (response.data != null)
                                        {
                                            this.list = response.data.data.list
                                            this.item = this.list[0]
                                            this.country_name = this.item.country_name
                                            this.country_name = this.country_name.toUpperCase()
                                        }
                                    })
                            }
                        let curDate = new Date()
                        curDate = curDate.toISOString().substr(0,10)
                        this.grn.grn_date = curDate                
                        this.grn.po = po
                        this.grn.po_num = po.po_num
                        this.isPORetrieved = true
                    }
                }
            })
        }
        else
        {
            this.isPORetrieved = false
            this.poNum = ''
        }
        
    },
    data: () => {
        return {
            btnDisplay :'Cancel',
            poNum: '',
            modalMsg: '',
            isPORetrieved: false,
            title:'New GRN',
            errorMessage:'',
            country_name:'',
            poLookupUrl : apiPOLookup,
            modalShow:false,
            modalCancelShow:false,
            grnDocNo :'test',
            isValid : true,
            font:'ukai',
            received_qty:0,
            existingGrns: [],
            grn: 
            {
                grn_num: '',
                grn_date: '',
                po_num:'',
                remarks:'',
                grn_items:{},
                po: {
                    grns:{}
                }
            },
        }
    },
    methods:
    {
        printGRN(row) 
            {
                var grn_num = row.grn_num
                    var r = []
                    var grnsItems = []
                    var groTotalAmount = 0
                    r = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                    ]
                    grnsItems.push(r)
         
                    var items = row.grn_items
                    for (let key in items) {
                        var data = items[key]
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null) 
                        {
                            data.product_name = ""
                        }
                        r = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                        ]
                        grnsItems.push(r)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN '+ this.country_name + ' GOODS RECEIVED NOTE',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'GRN #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: grn_num,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [

                                                {
                                                    text: 'GRN Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: row.grn_date_friendly,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Reference PO #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: row.po_num,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: grn_num,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 68, '*', 45, 45],
                                    body: grnsItems

                                }, // table
                            },
                            {
                                text: 'Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: row.remarks,
                                style: 'notesText'
                            },
                        {
                          columns: [
                                {
                                    stack: [
                                        { 
                                            text: 'Received By',
                                            style:'signaturePlaceholder'
                                        },

                                        { 
                                            text: '______________________________',
                                            style:'signaturePlaceholder'
                                        },
                                        { 
                                            text: 'Name  :',
                                            style:'signatureName'
                                            
                                        },
                                        { 
                                            text: 'Date  :',
                                            style:'signatureJobTitle'
                                            
                                        }
                                        ],
                                width: 160
                                },                
                            ]
                        },  
                        ],
                        styles: {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 22,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:this.font
                        }
                    }
                    pdfMake.createPdf(dd).open();
        },
        print() 
            {
                    var poNum = this.grn.po_num
                    var row = []
                    var date = new Date(this.grn.po.po_date)
                    var poDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    var poItems = []
                    var deliveryDate = '-'
                    if(this.grn.po.po_date_eta != null)
                    {
                        var d = new Date(this.grn.po.po_date_eta)
                        deliveryDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + ((d.getMonth() + 1) > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear()
                    }
                    row = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'PO Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                        {
                            text:'Received Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        }
                    ]
                    poItems.push(row)
                    var items = this.grn.po.po_items
                    for (let key in items) {
                        var data = items[key]
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var qty_received = (data.qty_received* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null) 
                        {
                            data.product_name = ""
                        }
                        row = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                            {
                                text: qty_received,
                                style: 'itemNumber'
                            },
                        ]
                        poItems.push(row)
                    }
                    var grnItems = []
                    var grnRow = []
                    grnRow = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'GRN #',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'GRN Date',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Generated By',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },

                    ]
                   grnItems.push(grnRow)
                    var grns = this.grn.po.grns
                    for (let key in grns) {
                        var gd = grns[key]
                        grnRow = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: gd.grn_num,
                                style: 'itemText'
                            },
                            {
                                text: gd.grn_date_friendly,
                                style: 'itemText'
                            },
                            {
                                text: gd.author_user_shortname,
                                style: 'itemText'
                            },

                        ]
                        grnItems.push(grnRow)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN '+ this.country_name + ' GOODS RECEIVED NOTE',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'PO #',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: poNum,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'PO Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: poDate,
                                                    style: 'invoiceSubValue',
                                                    width: 130

                                                }, 
                                            ]
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Supplier',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: this.grn.po.supplier_full,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'PO Type',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: this.grn.po.po_type,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                            ]

                                        },
                                        {
                                            columns: [

                                             {
                                                    text: 'Stock Location',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: this.grn.po.location_full,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'Delivery Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 90
                                                },
                                                {
                                                    text: '-',
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                            ]

                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'PO Status',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: this.grn.po.po_status,
                                                    style: 'invoiceSubValue',
                                                    width: 130
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'Fulfilment Status',
                                                    style: 'invoiceSubTitle',
                                                    width: 90

                                                },
                                                {
                                                    text: this.grn.po.po_fulfilment_status,
                                                    style: 'invoiceSubValue',
                                                    width: 130

                                                }, 
                                            ]

                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: poNum,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            {
                                text: 'GRN Lists',
                                style: 'notesTitle'
                            },
                            {
                            table: {
                                // headers are automatically repeated if the table spans over multiple pages
                                // you can declare how many rows should be treated as headers
                                headerRows: 0,
                                widths: [25,'auto',80,'auto'],
                                body: grnItems
                            }, // table
                            layout: 'lightHorizontalLines'
                            },
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 68, '*', 65, 65],
                                    body: poItems

                                }, // table
                            },
                            {
                                text: 'PO Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: this.grn.po.remarks,
                                style: 'notesText'
                            },
                        ],
                        styles: 
                        {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 22,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:this.font
                        }
                    }
                    pdfMake.createPdf(dd).open();
                },
        retrievePO()
        {
            if (this.grn.po_num != '')
            {
                this.isPORetrieved = true
            }
        },
        cancelGrn()
        {
            this.grn.po_num = "";
            this.isPORetrieved = false;
        },
        setPoId(obj)
        {

            if (obj !== null)
            {
                let curDate = new Date()
                curDate = curDate.toISOString().substr(0,10)
                this.grn.grn_date = curDate                
                this.grn.po = obj
                if(obj.country_id != null)
                {
                    if(obj.country_id == 'TH')
                    {
                        this.font = 'Garuda'
                    }
                    else if(obj.country_id == 'KH')
                    {
                        this.font = 'Hanumanb'
                    }

                    axios.get(apiCountryLookup, {params: {q: obj.country_id}})
                        .then(response => 
                        {

                            if (response.data != null)
                            {
                                this.list = response.data.data.list
                                this.item = this.list[0]

                                this.country_name = this.item.country_name
                                this.country_name = this.country_name.toUpperCase()
                            }
                        })
                }
                this.grn.po_num = obj.po_num
            }
            else
            {
                this.grn.po_num = null
            }
        },
        confirmSave()
        {
          this.modalShow = true
        },
        confirmCancel()
        {
            this.modalCancelShow = true
        },
        hideModal () 
        {
            this.$refs.myModalRef.hide()
            this.$router.push({ name: 'Goods Receive Note (GRN) With PO'})
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
        save()
        {
            axios.post(apiGRNSave, this.grn, authHeader())
                        .then (res => { 
                        var r = res.data
                        
                        if (r.code == 1)
                        {
                            this.grnDocNo = r.data.grn_num
                            this.$refs.myModalRef.show()
                        }
                        else
                        {
                            this.errorMessage = r.msg
                            this.$refs.myErrorModalRef.show()
                        }
                        })
            .catch(error => alert(error))

        },
        cancel()
        {
            this.$router.push({ name: 'Goods Receive Note (GRN) With PO'})
        },
        back()
        {
            this.$router.push({ name: 'Goods Receive Note (GRN) With PO'})
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/grn/grn.vue